import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { appConstants } from 'modules';
import { ExpenseIcon, Font, XymSpacer, P } from 'components';
import { ImportExportMode } from './styles';
import { withTheme } from 'styled-components';
import _ from 'lodash';

const { names } = appConstants;
const { appName } = names;

const Export = withTheme(forwardRef((props, ref) => {
  const { theme, exportActive, type, expenseMode, setImportData, setImportMode, setIsMergeOperation } = props;

  const { generalPreferences: { selectedTheme } } = useSelector(state => state.preferences);
  const { transactionsData } = useSelector(state => state.institutions);
  const { expensesData } = useSelector(state => state.expenses);
  const data = expenseMode ? expensesData : transactionsData;
  const paynesGrey = theme.colors.neutral.paynesGrey;
  const modeElements = expenseMode ? 'expenses and goals' : type;

  return (
    <ImportExportMode
      $theme={theme}
      $selectedTheme={selectedTheme}
      $active={exportActive}
      $visible={!_.isEmpty(data)}
      onClick={() => {
        ref.current.value = '';
        setImportData(null);
        setImportMode(false);
        setIsMergeOperation(false);
      }}
    >
      <ExpenseIcon
        icon='fa-solid fa-file-export'
        bgColorDark={exportActive && paynesGrey}
        size={3}
        fontSize={1.5}
        alwaysVisible={true}
      />

      <div>
        <Font weight='semibold'>
          Export my {type}.
        </Font>

        <XymSpacer size={0.125} />

        <P size={0.75}>
          Exports all {modeElements} to a {expenseMode ? 'JSON' : 'CSV'} file, as a backup for this account,
          or for use with another {expenseMode ? 'account' : `${appName} account or app`}.
        </P>
      </div>
    </ImportExportMode>
  );
}));

export { Export };